import { TestedParty } from './tested-party';
import { TypeOfPrimaryFunctionOption } from './type-of-primary-function-option';
import { CharacterizationFunctionPerformed } from './characterization-function-performed';
import { IndustrialCodeValue } from './industrial-code-value';
import { IndustrialCodeType } from './industrial-code-type';

export class Characterization {
  characterizationId: number;
  description: string;
  typeOfPrimaryFunctionOption = new TypeOfPrimaryFunctionOption();
  testedParty: TestedParty;
  characterizationFunctionsPerformed: CharacterizationFunctionPerformed[] = [];
  codeType: IndustrialCodeType;
  industrialCodeValue: IndustrialCodeValue;
}
